import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Adjusted path to match structure
import TransitionLoader from './common/TransitionLoader';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 1. Wait for Auth to initialize
  if (loading) {
    return <TransitionLoader />; 
  }

  // 2. Not Logged In? -> Go to Login
  if (!user) {
    // Save where they were trying to go so we can send them back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. 🛡️ PROFILE CHECK: Logged in but profile NOT complete?
  // We must allow them to access the '/complete-profile' page itself to avoid infinite loops.
  if (!user.profileComplete && location.pathname !== '/complete-profile') {
    return <Navigate to="/complete-profile" replace />;
  }

  // 4. If Profile is Complete but they try to go back to '/complete-profile' manually?
  // Optional: Redirect them to dashboard so they don't fill it again.
  if (user.profileComplete && location.pathname === '/complete-profile') {
    return <Navigate to="/dashboard" replace />;
  }

  // 5. Access Granted
  return children;
};

export default ProtectedRoute;